import {
    Box,
    Card,
    Typography,
    Grid,
    Skeleton,
    Tooltip,
    IconButton,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { Visibility } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const ClientCardView = ({ data = [], loading }: any) => {
    const navigate = useNavigate();

    // const getCategoryLabel = (value?: string) => {
    //     return (
    //         CLIENT_CATEGORIES.find((cat) => cat.value === value)?.label || "--"
    //     );
    // };

    // const getSubCategoryLabel = (
    //     categoryValue?: string,
    //     subCategoryValue?: string
    // ) => {
    //     const category = CLIENT_CATEGORIES.find(
    //         (cat) => cat.value === categoryValue
    //     );

    //     return (
    //         category?.subCategories?.find(
    //             (sub) => sub.value === subCategoryValue
    //         )?.label || "--"
    //     );
    // };

    const Actions = ({ data }: any) => {
    const handleView = () => {
      navigate(`/atom-pro/mca/${data?.id}`);
    };

    return (
      <Box display="flex" gap={1}>
        <Tooltip title="View">
          <IconButton onClick={handleView} size="small">
            <Visibility />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

    if (loading) {
        return (
            <Grid container spacing={2}>
                {[...Array(6)].map((_, i) => (
                    <Grid item xs={12} md={4} key={i}>
                        <Skeleton variant="rectangular" height={180} />
                    </Grid>
                ))}
            </Grid>
        );
    }

    return (
        <Grid container spacing={2}>
            {data.map((row: any) => {
                const client = row?.client;

                return (
                    <Grid item xs={12} md={4} key={row.id}>
                        <Card
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                background:
                                    "linear-gradient(145deg, #f0f5fa, #bdbec1)",
                                color: "#000",
                                cursor: "pointer",
                                transition: "0.3s",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
                                },
                            }}
                        >
                            {/* Header */}
                            <Box display="flex" alignItems="center" gap={2} mb={2}>
                                <Box
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: 2,
                                        background: "rgba(255,255,255,0.08)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <BusinessIcon />
                                </Box>

                                <Box>
                                    <Typography fontWeight={600}>
                                        {client?.displayName || "--"}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{ opacity: 0.7 }}
                                    >
                                        CIN: {client?.cin || "--"}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Details */}
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography variant="caption" sx={{ opacity: 0.6 }}>
                                        Client ID
                                    </Typography>
                                    <Typography>
                                        {client?.clientId || "--"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography variant="caption" sx={{ opacity: 0.6 }}>
                                        Category
                                    </Typography>
                                    <Typography>
                                        {/* {getCategoryLabel(client?.category)} */}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography variant="caption" sx={{ opacity: 0.6 }}>
                                        Sub Category
                                    </Typography>
                                    <Typography>
                                        {/* {getSubCategoryLabel(
                                            client?.category,
                                            client?.subCategory
                                        )} */}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography variant="caption" sx={{ opacity: 0.6 }}>
                                        Actions
                                    </Typography>
                                    <Typography>
                                        <Actions data={row} />
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default ClientCardView;
